import Moment from "react-moment";
import React from "react";

export const DateTimeFromNow = function(props) {
    if(props.value === null) {
        return <span>Unavailable</span>;
    }
    return <Moment fromNow>{props.value}</Moment>;
};